import { useGetTeamsQuery } from '../consumer-api'

export const useGetTeams = () => useGetTeamsQuery()
